export function conversationFooterRole(
  active: { service: string; room?: string | null } | null,
): string {
  if (active === null) return '目前對話未選';
  return `目前對話 ${active.service} · ${active.room ?? '—'}`;
}

export function densityToggleLabel(isCompact: boolean): string {
  return isCompact ? '緊→寬' : '寬→緊';
}
